














































































































































































































































import FileUpload from "@/components/shared/FileUpload.vue";
import {
  insertArticle,
  myArticles,
  removeArticle,
  updateArticle,
} from "@/graphql/article";
import { IArticle } from "@/models/Article.model";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    FileUpload,
  },
  apollo: {
    myArticles() {
      return { query: myArticles, skip: true, variables: { conference: "" } };
    },
  },
})
export default class MyArticlesTable extends Vue {
  articles: IArticle[] = [];

  article: any = {};
  get conference() {
    return this.$store.getters.getConferenceId;
  }

  get topics() {
    return this.$store.getters.getTopics;
  }

  async mounted() {
    const item = localStorage.getItem("conference");
    // @ts-ignore
    const _id = JSON.parse(item)._id;
    this.$apollo.queries.myArticles.setVariables({
      conference: _id,
    });
    this.$apollo.queries.myArticles.skip = false;
    await this.$apollo.queries.myArticles.refetch();
  }

  edit(article: IArticle) {
    const el = document.getElementById("editModal");
    if (el) el.classList.add("is-active");
    this.article = Object.assign({}, article);
  }

  newArticle(article: IArticle) {
    const el = document.getElementById("insertModal");
    if (el) el.classList.add("is-active");
    this.article = Object.assign({}, article);
  }

  close(id: string) {
    const el = document.getElementById(id);
    if (el) el.classList.remove("is-active");
  }

  submit = true;
  disableSubmit() {
    this.submit = true;
  }

  enableSubmit() {
    this.submit = false;
  }

  uploaded(link: string) {
    this.article.link = link;
  }

  async editArticle() {
    this.article.conference = this.conference;
    if (this.article.reviewer)
      this.article.reviewer = this.article.reviewer._id;
    else this.article.reviewer = "5f89b60263e4982da44d855f";
    const res = await this.$apollo.mutate({
      mutation: updateArticle(this.article),
    });
    this.$apollo.queries.myArticles.skip = false;
    await this.$apollo.queries.myArticles.refetch();
    if (res) alert("updated successfully!");
    this.close("editModal");
  }

  async insertArticle() {
    if (!this.article.link) return alert("please upload your paper");
    this.article.conference = this.conference;
    const res = await this.$apollo.mutate({
      mutation: insertArticle(this.article),
    });
    this.$apollo.queries.myArticles.skip = false;
    await this.$apollo.queries.myArticles.refetch();
    this.close("insertModal");
  }
  async removeArticle(_id: string) {
    const confirmation = confirm(
      "are you sure you want to delete this article ?"
    );
    if (!confirmation) return;
    try {
      const res = await this.$apollo.mutate({
        mutation: removeArticle(this.conference, _id),
      });
      this.$apollo.queries.myArticles.skip = false;
      await this.$apollo.queries.myArticles.refetch();
      alert("article deleted successfully");
    } catch {
      alert("an error has occured");
    }
  }
}
